import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface TemplateExportRequest {
	templateTypes?: string[];
}

export const useTemplateExportMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async (request: TemplateExportRequest = {}) => {
			const systemJob = await userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'template/export' }),
				'POST',
				request
			);
			return systemJob as Api.ISystemJob;
		},
		onError,
		onSuccess,
	});
};
